module.exports = __webpack_public_path__ + "img/qa_fc.b7b8643a.svg";